"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const icons = __importStar(require("../../internal/icons"));
const utils_1 = require("../../internal/utils");
function loadIcons(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
icon, context, helper, callback) {
    let argIcon = undefined;
    if (icon) {
        if (utils_1.isPromise(icon)) {
            icon.then((i) => {
                loadIcons(i, context.toCurrentContext(), helper, callback);
            });
        }
        else {
            const iconList = icons.toNormarizeArray(icon);
            iconList.forEach((i) => {
                if (i.font && i.content) {
                    helper.testFontLoad(i.font, i.content, context);
                }
            });
            argIcon = iconList;
        }
    }
    callback(argIcon, context);
}
exports.loadIcons = loadIcons;
